import { Dispatch } from "redux";
import { resources } from "@constants/hardcoded-strings";
import { CancelWorkflowChangeRequestModal } from "@containers/modals/cancel-workflow-change-request-modal/cancel-workflow-change-request-modal";
import { CreateWorkflowChangeRequestModal } from "@containers/modals/create-workflow-change-request-modal/create-workflow-change-request-modal";
import { DeployNowWorkflowChangeRequestModal } from "@containers/modals/deploy-now-workflow-change-request-modal/deploy-now-workflow-change-request-modal";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { ModalTypes } from "@enums/modal-types";
import { ModalContextData } from "@idw-types/context";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { updateWorkflowChangeRequestRequest } from "@requests/service-configuration";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";

export const deployWorkflow = async (
    dispatch: Dispatch,
    workflowId: string,
    changeRequestStatuses: Array<ChangeRequestStatusTypes>,
    currentStepIndex: number
): Promise<any> => {
    const currentChangeRequestStatus = changeRequestStatuses[currentStepIndex];

    if (currentStepIndex < changeRequestStatuses.length) {
        const body = changeRequestStatuses[currentStepIndex] === ChangeRequestStatusTypes.DEPLOYED
            ? { deploymentDate: new Date().getTime() }
            : null;

        const response = await performWorkflowChangeRequestStep(
            dispatch,
            workflowId,
            currentChangeRequestStatus,
            body
        );

        if (response && changeRequestStatuses[currentStepIndex] !== ChangeRequestStatusTypes.DEPLOYED) {
            return await deployWorkflow(dispatch, workflowId, changeRequestStatuses, currentStepIndex + 1);
        } else {
            return response;
        }
    }

    return null;
};

export const performWorkflowChangeRequestStep = async (
    dispatch: Dispatch,
    workflowId: string,
    changeRequestStatus: ChangeRequestStatusTypes,
    body: { [key: string]: any }
) => {
    const { data, error } = await updateWorkflowChangeRequestRequest(workflowId, body, changeRequestStatus);

    if (data?.transferObject) {
        return data.transferObject;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateWorkflowChangeRequest.error.title,
            resources.requests.updateWorkflowChangeRequest.error.message,
            error,
            null,
            body
        );
    }
    return null;
};

export const clickWorkflowChangeRequestActionHandler = (
    onSubmitHandler: (onModalClose: () => void) => Promise<WorkflowChangeRequest>,
    modalContext: ModalContextData,
    workflowName: string,
    workflowId: string,
    workflowChangeRequestStatus: ChangeRequestStatusTypes,
    modalType: ModalTypes
) => {
    const renderModal = (onModalClose: () => void) => {
        switch (modalType) {
            case ModalTypes.CreateWorkflowChangeRequest:
                return <CreateWorkflowChangeRequestModal
                    onModalClose={onModalClose}
                    onSubmitHandler={onSubmitHandler}
                    workflowName={workflowName}
                />;
            case ModalTypes.CancelWorkflowChangeRequest:
                return <CancelWorkflowChangeRequestModal
                    onModalClose={onModalClose}
                    onSubmitHandler={onSubmitHandler}
                    workflowName={workflowName}
                />;
            case ModalTypes.DeployNowWorkflowChangeRequest:
                return <DeployNowWorkflowChangeRequestModal
                    onModalClose={onModalClose}
                    onSubmitHandler={onSubmitHandler}
                    workflowName={workflowName}
                    workflowId={workflowId}
                    workflowChangeRequestStatus={workflowChangeRequestStatus}
                />;
            default:
                return null;
        }

    };

    modalContext.setModalState({
        modalType: modalType,
        renderFunction: renderModal
    });
};